"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SR_APP_WINDOW_BRIDGE = exports.HTTP_CODE_ERROR = exports.DEFAULT_ERROR_CODE = exports.DEFAULT_ERROR_MSG = exports.DEFAULT_REQUEST_TIMEOUT = exports.UNAUTHORIZED_VISIT_DESC = exports.RESPONSE_CODE = void 0;
// 请求约定的协议
var RESPONSE_CODE;
(function (RESPONSE_CODE) {
    RESPONSE_CODE["SUCCESS"] = "Success";
    RESPONSE_CODE["FAIL"] = "FAIL";
    RESPONSE_CODE["AUTH_FAIL"] = "AUTH_FAIL";
    RESPONSE_CODE["UNAUTHORIZED_VISIT"] = "UNAUTHORIZED_VISIT";
})(RESPONSE_CODE = exports.RESPONSE_CODE || (exports.RESPONSE_CODE = {}));
// -------------- 常量
exports.UNAUTHORIZED_VISIT_DESC = '未授权访问，请联系管理员。'; // 没有权限的提示文案
exports.DEFAULT_REQUEST_TIMEOUT = 1000 * 6; // 请求默认超时时间
exports.DEFAULT_ERROR_MSG = '系统繁忙，请稍后再试'; // 请求默认错误 `msg`
exports.DEFAULT_ERROR_CODE = -1; // 请求默认 `code`
exports.HTTP_CODE_ERROR = {
    400: '请求错误。(400)',
    401: '未授权的访问。(401)',
    403: '访问被禁止。(403)',
    404: '资源不存在。(404)',
    500: '服务器繁忙，请稍后再试。(500)',
    502: '服务器繁忙，请稍后再试。(502)',
    503: '服务器繁忙，请稍后再试。(503)',
    504: '请求超时，请稍后再试。（504）',
};
// window.SR_APP_WINDOW_BRIDGE 
exports.SR_APP_WINDOW_BRIDGE = 'SR_APP_WINDOW_BRIDGE';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9jb25zdGFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsVUFBVTtBQUNWLElBQVksYUFLWDtBQUxELFdBQVksYUFBYTtJQUN2QixvQ0FBbUIsQ0FBQTtJQUNuQiw4QkFBYSxDQUFBO0lBQ2Isd0NBQXVCLENBQUE7SUFDdkIsMERBQXlDLENBQUE7QUFDM0MsQ0FBQyxFQUxXLGFBQWEsR0FBYixxQkFBYSxLQUFiLHFCQUFhLFFBS3hCO0FBY0Qsb0JBQW9CO0FBRVAsUUFBQSx1QkFBdUIsR0FBRyxlQUFlLENBQUMsQ0FBQyxZQUFZO0FBQ3ZELFFBQUEsdUJBQXVCLEdBQUcsSUFBSSxHQUFHLENBQUMsQ0FBQyxDQUFDLFdBQVc7QUFDL0MsUUFBQSxpQkFBaUIsR0FBRyxZQUFZLENBQUMsQ0FBQyxlQUFlO0FBQ2pELFFBQUEsa0JBQWtCLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxjQUFjO0FBRXZDLFFBQUEsZUFBZSxHQUEyQjtJQUNyRCxHQUFHLEVBQUUsWUFBWTtJQUNqQixHQUFHLEVBQUUsY0FBYztJQUNuQixHQUFHLEVBQUUsYUFBYTtJQUNsQixHQUFHLEVBQUUsYUFBYTtJQUNsQixHQUFHLEVBQUUsbUJBQW1CO0lBQ3hCLEdBQUcsRUFBRSxtQkFBbUI7SUFDeEIsR0FBRyxFQUFFLG1CQUFtQjtJQUN4QixHQUFHLEVBQUUsa0JBQWtCO0NBQ3hCLENBQUM7QUFFRiwrQkFBK0I7QUFDbEIsUUFBQSxvQkFBb0IsR0FBRyxzQkFBc0IsQ0FBQyJ9